import { normalizeProductInfo } from './normalize-product-info'
import { normalizePromotionProductInfo } from '@/common/normalize/normalize-promotion-product-info'

export const PURCHASE_ACTION_TYPE = {
  PAYLETTER_CALL: 'PAYLETTER_CALL',
  PUT_UPCOMING_PAYMENTS: 'PUT_UPCOMING_PAYMENTS',
  SHOW_INAPP_ALERT: 'SHOW_INAPP_ALERT',
  SHOW_ALERT: 'SHOW_ALERT',
  SHOW_100_PROMOTION_MODAL: 'SHOW_100_PROMOTION_MODAL',
  SHOW_100_PROMOTION_CANCEL_NOTI_MODAL: 'SHOW_100_PROMOTION_CANCEL_NOTI_MODAL',
}

/**
 *
 * @param {*} rawData
 * @returns {object} {actionType: 'PAYLETTER_CALL' | 'PUT_UPCOMING_PAYMENTS' | 'SHOW_ALERT' | 'SHOW_100_PROMOTION_MODAL' | 'SHOW_100_PROMOTION_CANCEL_NOTI_MODAL'}
 */
export const normalizeCheckPurchaseAction = (rawData) => {
  if (!rawData) return
  const actionType = rawData?.action_type
  return {
    actionType,
    requestProductInfo: normalizeProductInfo(rawData.request_product_info),
    requestNonePromotionProductInfo:
      normalizePromotionProductInfo(
        rawData?.request_none_100_promotion_product_info,
      ) ?? {},
  }
}
